import React, { useEffect } from 'react';
import { initializeStarCanvas } from 'utils';

import '../Pages.scss';

function NotFound() {
  // Initialize star canvas
  useEffect(() => {
    const cleanup = initializeStarCanvas('star-canvas', {
      starCount: 400,
      maxSpeed: 0.7,
    });

    return cleanup;
  }, []);

  return (
    <div className='gigacore-theme'>
      <canvas id='star-canvas'></canvas>
      <div className='gigacore-container'>
        <h1 className='gigacore-title'>404</h1>
        <h2 className='gigacore-subtitle'>Page Not Found</h2>
      </div>
    </div>
  );
}

export default NotFound;
